module.exports = __webpack_public_path__ + "img/products_icon.8ab4acd6.svg";